import { render, staticRenderFns } from "./InvoicePrint.vue?vue&type=template&id=2231bfdc"
import script from "./InvoicePrint.vue?vue&type=script&lang=js"
export * from "./InvoicePrint.vue?vue&type=script&lang=js"
import style0 from "./InvoicePrint.vue?vue&type=style&index=0&id=2231bfdc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports